import { Segmented as SegmentedAntd } from 'antd';
import styled from 'styled-components';

const SegmedtedStyled = styled(SegmentedAntd)`
    width: 100%;
    margin: 8px 0px;
    label {
        width: 100%;
    }
`;

/** @param {import("antd").SegmentedProps} */
function Segmented({ options, ...props }) {
    return <SegmedtedStyled options={options} {...props} />;
}

export default Segmented;
